import { RootState } from '@app/redux/root-reducer';

export const selectDesignationState = (store: RootState) => store.designationsReducer.designation;

export const selectDeleteDesignationState = (state: RootState) =>
  state.designationsReducer.deleteDesignation;

export const selectAddDesignationState = (store: RootState) =>
  store.designationsReducer.addDesignation;
